import { Action } from '@ngrx/store'
import * as StreetTypesTypes from './street-types.types'
import { StreetType } from './street-types.interface'
import { Street } from '../streets/streets.interface'

// Fetch Street Types
export class FetchStreetTypesRequest implements Action {
  readonly type = StreetTypesTypes.FETCH_STREET_TYPES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchStreetTypesSuccess implements Action {
  readonly type = StreetTypesTypes.FETCH_STREET_TYPES_SUCCESS
  constructor(
    public payload: StreetType[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchStreetTypesFailure implements Action {
  readonly type = StreetTypesTypes.FETCH_STREET_TYPES_FAILURE
  constructor(public payload: any) {}
}

// Fetch Street Type
export class FetchStreetTypeRequest implements Action {
  readonly type = StreetTypesTypes.FETCH_STREET_TYPE_REQUEST
  constructor(public id: number) {}
}

export class FetchStreetTypeSuccess implements Action {
  readonly type = StreetTypesTypes.FETCH_STREET_TYPE_SUCCESS
  constructor(public payload: Street) {}
}

export class FetchStreetTypeFailure implements Action {
  readonly type = StreetTypesTypes.FETCH_STREET_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Delete Street Type
export class DeleteStreetTypeRequest implements Action {
  readonly type = StreetTypesTypes.DELETE_STREET_TYPE_REQUEST
  constructor(public id: number) {}
}

export class DeleteStreetTypeSuccess implements Action {
  readonly type = StreetTypesTypes.DELETE_STREET_TYPE_SUCCESS
  constructor() {}
}

export class DeleteStreetTypeFailure implements Action {
  readonly type = StreetTypesTypes.DELETE_STREET_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Create Street Type
export class CreateStreetTypeRequest implements Action {
  readonly type = StreetTypesTypes.CREATE_STREET_TYPE_REQUEST
  constructor(public payload) {}
}

export class CreateStreetTypeSuccess implements Action {
  readonly type = StreetTypesTypes.CREATE_STREET_TYPE_SUCCESS
  constructor() {}
}

export class CreateStreetTypeFailure implements Action {
  readonly type = StreetTypesTypes.CREATE_STREET_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Update Street Type
export class UpdateStreetTypeRequest implements Action {
  readonly type = StreetTypesTypes.UPDATE_STREET_TYPE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateStreetTypeSuccess implements Action {
  readonly type = StreetTypesTypes.UPDATE_STREET_TYPE_SUCCESS
  constructor() {}
}

export class UpdateStreetTypeFailure implements Action {
  readonly type = StreetTypesTypes.UPDATE_STREET_TYPE_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = StreetTypesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = StreetTypesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateStreetTypeRequest
  | UpdateStreetTypeSuccess
  | UpdateStreetTypeFailure
  | FetchStreetTypesSuccess
  | FetchStreetTypesFailure
  | FetchStreetTypesRequest
  | FetchStreetTypeSuccess
  | FetchStreetTypeFailure
  | FetchStreetTypeRequest
  | CreateStreetTypeRequest
  | CreateStreetTypeSuccess
  | CreateStreetTypeFailure
  | DeleteStreetTypeRequest
  | DeleteStreetTypeSuccess
  | DeleteStreetTypeFailure
  | SetDefaultData
  | UpdateField
  | FetchStreetTypesRequest
  | FetchStreetTypesSuccess
  | FetchStreetTypesFailure
